import { useTranslation } from 'react-i18next'
import type { SplitDirection } from './zone-ops'

interface SplitButtonsProps {
  onSplit: (direction: SplitDirection) => void
}

export function SplitButtons({ onSplit }: SplitButtonsProps) {
  const { t } = useTranslation()
  return (
    <div
      className="pointer-events-none absolute inset-0 z-20 flex items-center justify-center opacity-0 transition group-hover:opacity-100"
      data-testid="split-buttons"
    >
      <div className="pointer-events-auto flex items-center gap-1 rounded-full border border-stone-300 bg-white/95 px-1.5 py-1 shadow-lg backdrop-blur-sm dark:border-stone-700 dark:bg-stone-900/95">
        {/* Vertical-line icon = split into LEFT/RIGHT halves = 'row' */}
        {/* The per-button test ids are what E2E selects on: the aria-labels are
            translated (#154), so an accessible-name locator only works in the
            locale whose strings it was written against — the embed suite boots
            the designer in Spanish and would break on every copy change. */}
        <button
          type="button"
          data-testid="split-row"
          aria-label={t('canvas.split.leftRight')}
          onClick={e => {
            e.stopPropagation()
            onSplit('row')
          }}
          className="flex h-8 w-8 items-center justify-center rounded-full text-stone-700 transition hover:bg-sky-100 hover:text-sky-700 dark:text-stone-200 dark:hover:bg-sky-900 dark:hover:text-sky-200"
        >
          <svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" strokeWidth={1.6}>
            <rect x="2" y="2" width="12" height="12" rx="1.5" />
            <line x1="8" y1="2" x2="8" y2="14" />
          </svg>
        </button>
        {/* Horizontal-line icon = split into TOP/BOTTOM halves = 'column' */}
        <button
          type="button"
          data-testid="split-column"
          aria-label={t('canvas.split.topBottom')}
          onClick={e => {
            e.stopPropagation()
            onSplit('column')
          }}
          className="flex h-8 w-8 items-center justify-center rounded-full text-stone-700 transition hover:bg-sky-100 hover:text-sky-700 dark:text-stone-200 dark:hover:bg-sky-900 dark:hover:text-sky-200"
        >
          <svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" strokeWidth={1.6}>
            <rect x="2" y="2" width="12" height="12" rx="1.5" />
            <line x1="2" y1="8" x2="14" y2="8" />
          </svg>
        </button>
      </div>
    </div>
  )
}
